/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import Close from '@mui/icons-material/Close';

import { Button } from 'uikit/buttons';

import { SelectOptionContent } from './selectOption';

import styles from '../styles/selectedOption.module.scss';

const SelectedOption = ({
  selectedItem: {
    id,
    name,
    body,
    hex_color: color,
  },
  handleRemoveSelected,
  isReadOnly = false,
}) => (
  <li className={styles.element}>
    <SelectOptionContent name={name} body={body} color={color} />
    {!isReadOnly && (
      <Button
        className={styles.close}
        onClick={() => handleRemoveSelected(id)}
        variant="ghost"
        size="xsmall"
        icon={<Close />}
      />
    )}
  </li>
);

SelectedOption.propTypes = {
  selectedItem: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string,
    body: PropTypes.arrayOf(PropTypes.string),
    hex_color: PropTypes.string,
  }).isRequired,
  handleRemoveSelected: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool,
};

export default React.memo(SelectedOption);
